import { SET_CLUSTER_LIST } from "./types";

//Set Workspace
export const setClusterList = (payload) => {
  return {
    type: SET_CLUSTER_LIST,
    payload,
  };
};
